<script>
import { cn } from "$lib/utils";

let className = "";
export { className as class };
const _class = cn("size-4", "shrink-0", className);
</script>

<svg
  class={_class}
  xmlns="http://www.w3.org/2000/svg"
  fill="currentColor"
  width="24px"
  height="24px"
  viewBox="0 0 40 40"
  aria-label="Move Up icon"
  {...$$restProps}
>
  <path fill-rule="nonzero" d="M20 12l6 5.656-1.5 1.414-3.44-3.242V28h-2.12V15.828L15.5 19.07 14 17.656z"></path>
</svg>
